import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import LoginView from './views/Login.vue'
import RegisterView from './views/Register.vue'
import MyAccountView from './views/MyAccount.vue'
import SearchHourView from './views/SearchHour.vue'
import TakeHourView from './views/TakeHour.vue'
import HistoryView from './views/History.vue'
import RecoveryPassView from './views/RecoveryPass.vue'
import ResetPasswordView from './views/ResetPassword.vue'
import ConfirmHourView from './views/ConfirmHour.vue'
import CancelHourView from './views/CancelHour.vue'

Vue.use(Router)

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Buscar cita',
            component: SearchHourView,
        },
        {
            path: '/ingreso',
            name: 'Ingreso',
            component: LoginView,
            meta: {
                requiresNoAuth: true
            }
        },
        {
            path: '/registrarse',
            name: 'Registrarse',
            component: RegisterView,
            meta: {
                requiresNoAuth: true
            }
        },
        {
            path: '/recordar-contraseña',
            name: 'Recordar contraseña',
            component: RecoveryPassView,
            meta: {
                requiresNoAuth: true
            }
        },
        {
            path: '/reset-password',
            name: 'Restablecer contraseña',
            component: ResetPasswordView,
            meta: {
                requiresNoAuth: true
            }
        },
        {
            path: '/mi-cuenta',
            name: 'Mi cuenta',
            component: MyAccountView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/reservar-cita/:id',
            name: 'Reservar cita',
            component: TakeHourView,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/confirmar-cita/:token',
            name: 'Confirmar cita',
            component: ConfirmHourView,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/anular-cita/:token',
            name: 'Anular cita',
            component: CancelHourView,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/mis-citas',
            name: 'Mis citas',
            component: HistoryView,
            meta: {
                requiresAuth: true
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next()
            return
        }
        store.dispatch("saveFromUrl", to.fullPath);
        next('/ingreso')
    } else if (to.matched.some(record => record.meta.requiresNoAuth)) {
        if (store.getters.isLoggedIn) {
            next('/');
            return
        }
        next()
    } else {
        next()
    }
})

export default router
